/**
 * A URL the application does not serve. The server returned `index.html` with a 200, because the
 * catch-all cannot know which paths the router recognises — so the router says so here.
 */

import { Link } from 'react-router';
import { AppShell, PageHeader } from '~/layout/AppShell';
import { useScreen } from '~/layout/RouteAnnouncer';
import { EmptyState } from '~/ui/Feedback';
import { routes } from '~/lib/routes';

export function NotFound() {
  const headingRef = useScreen('Not found');

  return (
    <AppShell leaf="Not found">
      <PageHeader headingRef={headingRef} title="Not found" />
      <EmptyState>
        <p>
          This address does not match a screen the application serves. The link may be from an
          older version of the product, or a register code in it may have been mistyped — codes
          can be changed, and a retired one still resolves, but a code that was never held cannot.
        </p>
        <p style={{ marginTop: 10 }}>
          <Link to={routes.jurisdictions()}>Go to the jurisdictions list</Link>
        </p>
      </EmptyState>
    </AppShell>
  );
}
